export const AppLoader = () => {
  return <div className="loader-container">
      <img src={require('../../../assets/img/loader.gif')} alt="" />
    </div>
}
